import React from 'react';
import { Link } from 'react-router-dom';
import './WhatWeDoPage.css';

const WhatWeDoPage = ({ title, description, content, image }) => {
  return (
    <div className="what-we-do-page">
      <section className="page-hero">
        <div className="page-hero-overlay"></div>
        <div className="page-hero-content">
          <h1>{title}</h1>
          <p>{description}</p>
        </div>
      </section>

      <section className="content-section">
        <div className="container">
          <div className="content-grid">
            <div className="content-text">
              {content}
            </div>
            <div className="content-image">
              <img src={image} alt={title} />
            </div>
          </div>

          <div className="cta-box">
            <h3>Interested in Our Services?</h3>
            <p>Contact us to learn more about how we can help your organization</p>
            <Link to="/contact" className="btn btn-primary">Get in Touch</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WhatWeDoPage;
